import { SAMPLE_ENV } from "babel-dotenv";
console.log(`Hello ${SAMPLE_ENV}!`);

export function honesty() {
  return true;
}
